// extracted by mini-css-extract-plugin
export default {"container":"CardBook_container__egkUQ","description":"CardBook_description__6vAQX","preco":"CardBook_preco__Uvd0F"};